import React, { FC } from 'react'
import { Helmet } from 'react-helmet'

// eslint-disable-next-line import/prefer-default-export
export const SiteSeo: FC<{ title?: string; description?: string }> = ({ title, description }) => (
  <Helmet>
    <title>{title || 'Vista Design System'}</title>
    {!!description && <meta name="description" content={description} />}
  </Helmet>
)
